export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/fuli-icon.ef4f7c25.png";